<h2 mat-dialog-title>Configuración</h2>
<div mat-dialog-content>
  <mat-checkbox [(ngModel)]="mostrarDestinoOriginal" (change)="onToggle()">
    Mostrar destino original
  </mat-checkbox>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cerrar</button>
</div>
